import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import useUpdateMode from '@hooks/useUpdateMode'
import { saveAnswer } from '@utils/onboardingStorage'
import { useTranslation } from 'react-i18next'
import { useSearchParams, useSubmit } from 'react-router-dom'

const QUESTION_KEY = 'vibe'

const OPTIONS = [
  {
    value: 'Soft & reflective',
    translationKey: 'pages.onboarding.vibe.options.floaty',
    subtextKey: 'pages.onboarding.vibe.subtexts.floaty',
  },
  {
    value: 'Playful & open',
    translationKey: 'pages.onboarding.vibe.options.playful',
    subtextKey: 'pages.onboarding.vibe.subtexts.playful',
  },
  {
    value: 'A little chaotic',
    translationKey: 'pages.onboarding.vibe.options.chaotic',
    subtextKey: 'pages.onboarding.vibe.subtexts.chaotic',
  },
  {
    value: 'Ready to transform',
    translationKey: 'pages.onboarding.vibe.options.transformative',
    subtextKey: 'pages.onboarding.vibe.subtexts.transformative',
  },
]

export default function VibePage() {
  const submit = useSubmit()
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue =
    value && OPTIONS.some((option) => option.value === value)
      ? value
      : undefined
  const { isUpdate, postToReactNative } = useUpdateMode()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    // Get the answer value from the form
    const formData = new FormData(event.currentTarget)
    const value = formData.get('answer') as string

    if (!value) return

    const answer = {
      question_key: QUESTION_KEY,
      question: "What's your vibe today?",
      answer_key: value,
      answer: value,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(event.currentTarget)
    }
  }

  // Transform options to the format expected by QuestionPage
  const buttons = OPTIONS.map((option) => ({
    text: t(option.translationKey),
    subtext: t(option.subtextKey),
    value: option.value,
  }))

  return (
    <QuestionPage
      heading={t('pages.onboarding.vibe.heading')}
      buttons={buttons}
      onSubmit={handleSubmit}
      headingSize="text-3xl text-center whitespace-pre-line"
      buttonTextSize="text-xl"
      buttonBgColor="bg-white"
      preselectedValue={preselectedValue}
    />
  )
}
